import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const SkeletonLoader = () => {
    return (
        <Grid container spacing={2}>
            {[...Array(1)].map((_, index) => (
                <Grid item xs={12} key={index}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Skeleton variant="circular" width={50} height={50} />
                     
                    </div>
                    <div style={{ marginTop: 10, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                        {[...Array(6)].map((_, subIndex) => (
                            <React.Fragment key={subIndex}>
                                <Skeleton variant="text" width="100%" height={30} style={{ marginBottom: 5 }} />
                                <Skeleton variant="text" width="50%" height={10} style={{ marginBottom: 5 }} />
                            </React.Fragment>
                        ))}
                    </div>
                </Grid>
            ))}
        </Grid>
    );
};

export default SkeletonLoader;